import Alert from 'react-bootstrap/Alert';
import { useSelector, useDispatch } from 'react-redux';
import { CLEARERROR } from '../Redux/ActionTypes/ErrorsTypes';

const Errors = () => {
  const Erreur = useSelector(state => state.ErrorsReducer);
  const dispatch = useDispatch();

  if (!Erreur || Erreur.length === 0) return null;

  const handleDismiss = (id) => {
    dispatch({
      type: CLEARERROR,
      payload: id
    });
  };

  return (
    <div style={{
      position: 'fixed',
      top: '76px',
      right: '24px',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      maxWidth: '360px',
      width: '90%'
    }}>
      {Erreur.map((el, i) => (
        <Alert 
          key={el.id || i} 
          variant="danger" 
          onClose={() => handleDismiss(el.id)} 
          dismissible 
          className="mb-0 shadow-lg border-start border-4 border-danger"
          style={{ animation: 'slideInRight 0.3s cubic-bezier(0.4, 0, 0.2, 1)' }}
        >
          {el.msg}
        </Alert>
      ))}
    </div>
  );
};

export default Errors;
